import { render, staticRenderFns } from "./Page_DiscountPartnerListing.vue?vue&type=template&id=2c3a5722&scoped=true&"
import script from "./Page_DiscountPartnerListing.vue?vue&type=script&lang=js&"
export * from "./Page_DiscountPartnerListing.vue?vue&type=script&lang=js&"
import style0 from "./Page_DiscountPartnerListing.vue?vue&type=style&index=0&id=2c3a5722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a5722",
  null
  
)

export default component.exports